import { Component } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'era-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  public ids4ConfigId: string;
  public azureb2cConfigId: string;

  constructor(private readonly oidcSecurityService: OidcSecurityService) {
    const configs = oidcSecurityService.getConfigurations();
    this.ids4ConfigId = configs.find((config) => config.configId.startsWith('ids4'))?.configId;
    this.azureb2cConfigId = configs.find((config) => config.configId.startsWith('azureb2c'))?.configId;
  }

  login(configId: string) {
    this.oidcSecurityService.authorize(configId);
  }
}
